export type SettingKey = `settings.${string}`;
export interface ToggleUserSettingSuccessResponse {
  status: "success";
}
